import { Form, Input, Row, Col, Switch, Select } from 'antd';
import { useEffect, useRef, useState } from 'react';
import WebEditUniversal, { WebEditUniversalProps } from '../../system/WebEditUniversal';
import getList from '../../../utilsTsx/universal/getList';
import arrayHandle from '../../../utilsTs/baseLib/arrayHandle';
import fetchApi from '../../../utilsTsx/components/system/fetchApi';
import { getService } from '../../system/WebUniversal';

const SmsNotificationConfigEdit = (props: any) => {
    const apiId = 'smsNotificationConfig';
    const [form] = Form.useForm();
    const { defaultService, editMode } = props;
    const ref = useRef<any>(undefined);

    const [smsServiceData, setSmsServiceData] = useState<any>();
    const [smsNotificationModeData, setSmsNotificationModeData] = useState<any>();

    useEffect(() => {
        fetchApi.GET(defaultService,
            {
                query: {
                    apiId: 'smsService',
                    apiExtend: 'showList'
                }
            }).then(res => {
                if (res.success) {
                    setSmsServiceData(res.data);
                }
            })
        fetchApi.GET(defaultService,
            {
                query: {
                    apiId: 'generalData',
                    apiVariable: 'smsNotificationMode',
                    apiExtend: 'showLists'
                }
            }).then(res => {
                if (res.success) {
                    const { smsNotificationMode } = res.data;
                    setSmsNotificationModeData(smsNotificationMode);
                }
            })
    }, []);

    const extendProps: WebEditUniversalProps = {
        ...props,
        form,
        apiId,
        serviceId: 'business',
        formOptions: {
            instance: form,
            children: (<Row gutter={[8, 0]}>
                <Col span={12}>
                    <Form.Item
                        label="通知模式"
                        name="id"
                        rules={[{ required: true, message: '短信通知模式!' }]}>
                        <Select
                            placeholder="短信通知模式"
                            disabled={editMode === 'NEW' ? false : true}
                            showSearch={{
                                optionFilterProp: 'label',
                                filterOption: (input, option: any) =>
                                    option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
                            }}
                            options={getList.general2(smsNotificationModeData)} />
                    </Form.Item>
                </Col>

                <Col span={12}>
                    <Form.Item
                        label="短信服务"
                        name="smsServiceId"
                        rules={[{ required: true, message: '短信服务!' }]}>
                        <Select
                            placeholder="短信服务"
                            showSearch={{
                                optionFilterProp: 'label',
                                filterOption: (input, option: any) =>
                                    option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
                            }}
                            options={getList.general2(smsServiceData, { itemName: 'serviceName' })} />
                    </Form.Item>
                </Col>

                <Col span={4}>
                    <Form.Item
                        label="状态"
                        name="isUse"
                        valuePropName="checked"
                        initialValue={true}>
                        < Switch checked={true}
                            checkedChildren="启用"
                            unCheckedChildren="关闭" />
                    </Form.Item>
                </Col>

            </Row>)
        }
    };

    return (<WebEditUniversal ref={ref} {...extendProps} />)
}

export default SmsNotificationConfigEdit;